<div class="card shadow login-card m-auto" [formGroup]="parentForm">
  <div class="card-body accountStepperContent py-5">
    <div class="col d-flex">
      <div class="w-100">
        <div class="d-flex flex-row justify-content-between">
          <h1 class="card-title" id="card-title">
            Account Information
            <span class="text-danger small">*Required</span>
          </h1>

          <button
            class="btn btn-primary mb-2"
            matStepperNext
            (click)="completeAccountInformation()"
            [disabled]="!isFormValid"
            type="button"
          >
            Continue
          </button>
        </div>
        <div>
          <app-dynamic-form
            [jsonFormData]="accountField"
            [parentForm]="parentForm"
            [controlName]="'accountForm'"
            (isdynamicFormValid)="enableContinueButton($event)"
          ></app-dynamic-form>
        </div>
      </div>
    </div>
  </div>
</div>
